module.exports = __webpack_public_path__ + "static/media/feature-sponsored-locations2.d71ecb4d.png";